<template>
    <IOContainer :maxHeight="maxHeight" style="min-height: 8rem">
        <v-form
            v-if="calc"
            ref="form"
            lazy-validation
            @submit.prevent="calculateClicked()"
            class="d-flex flex-column justify-space-between"
        >
            <div v-if="!calc.inputs" class="description">
                This calculation has no inputs ~(˘▾˘~)
            </div>
            <InputGroup :inputs="nonGroupedInputs" />
            <v-row
                v-if="calc.inputGroups && calc.inputGroups.length > 0"
                v-for="(inputGroup, index) in calc.inputGroups"
            >
                <v-col cols="12">
                    <CalcInputGroup :input-group="inputGroup" :key="index" />
                </v-col>
            </v-row>
            <!-- hidden submit button to make "submit on enter" work -->
            <v-btn type="submit" v-show="false"></v-btn>
        </v-form>
    </IOContainer>
</template>
<script setup>
import { ref, computed, watch } from 'vue'
import CalcInputGroup from './CalcInputGroup.vue'
import InputGroup from './InputGroup.vue'
import IOContainer from '../shared/IOContainer.vue'

const props = defineProps({
    calc: {
        type: Object,
        required: true,
    },
    maxHeight: {
        type: String,
        default: '100%',
    },
})
const emit = defineEmits(['submit'])

const form = ref(null)

const nonGroupedInputs = computed(() => {
    return props.calc.inputs.filter((i) => !isInputGrouped(i))
})

watch(
    () => props.calc.inputGroups,
    (val) => {
        val.forEach((v) => {
            if (v.inputs) {
                v.inputs.forEach((i) => {
                    const input = props.calc.inputs.find(
                        (ci) => ci.inputId === i.inputId
                    )
                    input.value = i.value
                })
            }
        })
    },
    { deep: true }
)

async function calculateClicked() {
    const { valid } = await form.value.validate()
    if (!valid) return
    emit('submit')
}

function isInputGrouped(input) {
    for (let group in props.calc.inputGroups) {
        for (let i in props.calc.inputGroups[group].inputs) {
            if (
                props.calc.inputGroups[group].inputs[i].inputId ===
                input.inputId
            )
                return true
        }
    }
    return false
}
</script>
